/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Busy_Toast_DetailInputs */

const en_us2_swap_busy_toast_detail = /** @type {(inputs: Swap_Busy_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine taken: the plan doesn't change.`)
};

const pt_br2_swap_busy_toast_detail = /** @type {(inputs: Swap_Busy_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparelho ocupado: o plano não muda.`)
};

const es_419_swap_busy_toast_detail = /** @type {(inputs: Swap_Busy_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máquina ocupada: el plan no cambia.`)
};

const pt_pt2_swap_busy_toast_detail = /** @type {(inputs: Swap_Busy_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máquina ocupada: o plano não muda.`)
};

const fr_fr2_swap_busy_toast_detail = /** @type {(inputs: Swap_Busy_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine occupée : le programme ne change pas.`)
};

const de_de2_swap_busy_toast_detail = /** @type {(inputs: Swap_Busy_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerät besetzt: Der Plan ändert sich nicht.`)
};

const it_it2_swap_busy_toast_detail = /** @type {(inputs: Swap_Busy_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macchina occupata: la scheda non cambia.`)
};

/**
* | output |
* | --- |
* | "Machine taken: the plan doesn't change." |
*
* @param {Swap_Busy_Toast_DetailInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_busy_toast_detail = /** @type {((inputs?: Swap_Busy_Toast_DetailInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Busy_Toast_DetailInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_busy_toast_detail(inputs)
	if (locale === "es-419") return es_419_swap_busy_toast_detail(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_busy_toast_detail(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_busy_toast_detail(inputs)
	if (locale === "de-DE") return de_de2_swap_busy_toast_detail(inputs)
	if (locale === "it-IT") return it_it2_swap_busy_toast_detail(inputs)
	return en_us2_swap_busy_toast_detail(inputs)
});
export { swap_busy_toast_detail as "swap.busy_toast_detail" }